import type {PostReactionType} from '../../../services/socialFeedApi';

export const SUPPORTED_POST_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export const MAX_POST_IMAGE_SIZE_BYTES = 10 * 1024 * 1024;
export const MAX_POST_IMAGE_SOURCE_SIZE_BYTES = 40 * 1024 * 1024;
export const MAX_POST_IMAGE_COUNT = 4;
export const SUPPORTED_REEL_VIDEO_TYPES = ['video/mp4', 'video/quicktime', 'video/x-msvideo'];
export const MAX_REEL_VIDEO_SIZE_BYTES = 500 * 1024 * 1024;

export const REEL_PLACEHOLDER_BACKGROUNDS = [
  'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
  'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
  'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
  'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
  'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
];

export const HOME_HEADER_THEMES: Record<string, string> = {
  purple: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  pink: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
  blue: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
  green: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
  orange: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
  dark: 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
  rainbow: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
  gold: 'linear-gradient(135deg, #f7971e 0%, #ffd200 100%)',
};

export const HOME_HERO_STATS = [
  {label: 'Followers', value: '1.2K'},
  {label: 'Following', value: '342'},
  {label: 'Posts', value: '89'},
  {label: 'New Messages', value: '23', highlighted: true},
];

export const HOME_QUICK_STATS = [
  {label: 'Followers', value: '1,247'},
  {label: 'Following', value: '342'},
  {label: 'Posts', value: '89'},
  {label: 'Messages', value: '23 new', highlighted: true},
];

export const LIKE_SKIN_TONES = {
  default: '👍',
  light: '👍🏻',
  mediumLight: '👍🏼',
  medium: '👍🏽',
  mediumDark: '👍🏾',
  dark: '👍🏿',
} as const;

export const POST_REACTION_OPTIONS: Array<{
  type: PostReactionType;
  emoji: string;
  label: string;
}> = [
  {type: 'like', emoji: '\uD83D\uDC4D', label: 'Like'},
  {type: 'laugh', emoji: '\uD83D\uDE02', label: 'Laugh'},
  {type: 'cry', emoji: '\uD83D\uDE2D', label: 'Cry'},
  {type: 'love', emoji: '\u2764\uFE0F', label: 'Love'},
  {type: 'celebrate', emoji: '\uD83C\uDF89', label: 'Celebrate'},
  {type: 'fire', emoji: '\uD83D\uDD25', label: 'Exciting'},
];

export const DEFAULT_POST_REACTION_TYPE: PostReactionType = 'like';

export const POST_REACTION_BY_TYPE = POST_REACTION_OPTIONS.reduce((lookup, reaction) => {
  lookup[reaction.type] = reaction;
  return lookup;
}, {} as Record<PostReactionType, typeof POST_REACTION_OPTIONS[number]>);
